module.exports = __webpack_public_path__ + "img/1_04.fcd6c5a8.jpg";